// A profile avatar drawn in code from the nickname: two colours, a pattern and the initials,
// all chosen by a hash, so everyone gets a distinct, stable picture without uploading one.
import { hashString } from "@eb/shared";

const PALETTE = ["#e69f00", "#56b4e9", "#009e73", "#f0e442", "#0072b2", "#d55e00", "#cc79a7", "#8f7fe0"];

export function Avatar({ nickname, size = 64 }: { nickname: string; size?: number }) {
  const h = hashString(nickname.toLowerCase());
  const a = PALETTE[h % PALETTE.length];
  const b =
    PALETTE[(h >>> 3) % PALETTE.length] === a ? PALETTE[(h + 3) % PALETTE.length] : PALETTE[(h >>> 3) % PALETTE.length];
  const pattern = (h >>> 6) % 4;
  const initials =
    nickname
      .replace(/[^A-Za-z0-9]/g, "")
      .slice(0, 2)
      .toUpperCase() || "?";
  const id = `av${h.toString(36)}`;
  return (
    <svg
      className="avatar"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={`Avatar of ${nickname}`}
    >
      <defs>
        <clipPath id={id}>
          <circle cx="32" cy="32" r="32" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id})`}>
        <rect width="64" height="64" fill={a} />
        {pattern === 0 &&
          [0, 1, 2, 3].map((i) => (
            <rect
              key={i}
              x={-8 + i * 20}
              y="-8"
              width="9"
              height="80"
              fill={b}
              transform="rotate(25 32 32)"
              opacity="0.55"
            />
          ))}
        {pattern === 1 &&
          [12, 22, 32].map((r) => (
            <circle key={r} cx="32" cy="64" r={r} fill="none" stroke={b} strokeWidth="5" opacity="0.6" />
          ))}
        {pattern === 2 && <path d="M0 40 Q16 28 32 40 T64 40 V64 H0 Z" fill={b} opacity="0.7" />}
        {pattern === 3 &&
          [0, 1, 2, 3, 4].map((i) => (
            <rect
              key={i}
              x={6 + i * 11}
              y={44 - ((h >>> (i * 3)) % 4) * 8}
              width="7"
              height="40"
              rx="2"
              fill={b}
              opacity="0.65"
            />
          ))}
      </g>
      <text
        x="32"
        y="38"
        textAnchor="middle"
        fontSize="20"
        fontWeight="800"
        fill="#101318"
        stroke="#ffffff"
        strokeWidth="3"
        paintOrder="stroke"
        strokeLinejoin="round"
        fontFamily="system-ui, sans-serif"
      >
        {initials}
      </text>
    </svg>
  );
}
